module.exports = __webpack_public_path__ + "static/media/MasterCard.4cbdeeed.png";